import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import { Container } from "Components/Utilities";
import { asset } from "Services/BaseHelpers";

export default class Location extends React.Component {

    render () {
        return (
            <Authenticated title="Dashboard">
                <div className={ "py-8 lg:py-12 space-y-6 text-center mx-auto text-app-blue" }>
                    <div className={ "text-3xl text-app-blue font-bold" }>
                        Information
                    </div>
                    <div className={ "text-3xl text-app-blue font-bold" }>
                        Wednesday 15 October 2025
                    </div>
                </div>

                <div className="bg-app-light-blue py-10 lg:py-20">
                    <Container>
                        <div className="flex gap-6 lg:gap-20 flex-col-reverse lg:flex-row">
                            <div className="w-full lg:w-1/2">
                                <div className="aspect-w-1 aspect-h-1">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2481.347434497204!2d-0.1291806842294922!3d51.49947957963392!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604c5d5b5b5b5%3A0x5b5b5b5b5b5b5b5b!2sQEII%20Centre!5e0!3m2!1sen!2sus!4v1631542618471!5m2!1sen!2sus"
                                />
                                </div>
                            </div>
                            <div className="w-full lg:w-1/2 flex text-white flex-col justify-center">
                                <p className="text-5xl font-bold mb-12">Location</p>
                                <p className="mb-4 text-2xl">This year’s event will be held at:</p>
                                <p className={ "text-xl mb-2 font-bold" }>QEII Centre</p>
                                <p className={ "text-xl font-bold" }>Broad Sanctuary</p>
                                <p className={ "text-xl font-bold" }>Westminster</p>
                                <p className={ "text-xl font-bold" }>London</p>
                                <p className={ "text-xl font-bold" }>SW1P 3EE</p>
                            </div>
                        </div>
                    </Container>
                </div>

                <div className="bg-app-blue py-10 lg:py-20">
                    <Container>
                        <div className="space-y-6 text-xl text-white text-center">
                            <img src={ asset("images/calendar.svg") } className="w-28 mx-auto"/>

                            <div className="text-3xl text-white font-bold">
                                Agenda
                            </div>

                            <p>
                                Unbox digital health and explore the latest trends and innovations in the healthcare
                                industry.
                            </p>

                            <p>
                                Join us for a day of thought-provoking discussions and debates on digital healthcare,
                                with sessions to explore the three main pillars of digital health: virtual
                                consultations, health programmes and remote care.
                            </p>

                            <p>
                                You'll have the opportunity to learn more about Blua, which is digital healthcare from
                                Bupa, and see how we're using technology to improve the health and wellbeing of our
                                customers.
                            </p>

                            <p>
                                With expert speakers and panellists from across the global healthcare sector, this is
                                your chance to be part of the conversation.
                            </p>

                            <p className="font-bold">
                                More information about the agenda will be shared here in the coming weeks.
                            </p>
                        </div>
                    </Container>
                </div>

                <div className="bg-app-gray py-10 lg:py-20 flex items-center justify-center">
                    <div className="max-w-4xl w-full">
                        <p className={ "text-app-blue mb-6 text-xl md:text-2xl lg:text-3xl font-bold text-center" }>
                            Watch the highlights of last year's event below.
                        </p>

                        <div className="aspect-w-16 aspect-h-9">
                            <iframe
                                src="https://player.vimeo.com/video/920493880?h=cf82f804a0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                frameBorder="0"
                                allow="autoplay; fullscreen; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                    </div>
                </div>

                <div className="bg-app-light-blue py-10 lg:py-20">
                    <Container>
                        <div className="space-y-6 text-xl text-white text-center">
                            <img src={ asset("images/contact.png") } className="w-28 mx-auto"/>

                            <div className="text-3xl text-white font-bold">
                                Contact
                            </div>

                            <p>
                                Your registration is required by 30th September, after this time the registration site will be closed.
                            </p>

                            <p>
                                If you have any questions in the meantime or require any technical support, please contact us at <a href="mailto:healthcaresymposium@bupa.com" className="underline">healthcaresymposium@bupa.com</a>
                            </p>
                        </div>
                    </Container>
                </div>
            </Authenticated>
        );
    }
}
